import * as _ from 'lodash';
import { Registration } from '../interfaces';
import { FormControl } from '@angular/forms';

export class Element implements Registration.Form.IElement {
    displayDescription: boolean;
    order: number;
    title: string;
    description: string;
    value: any;
    inputType: string;
    inputKey: string;
    attributes: Registration.Form.IAttribute[];
    options: Registration.Form.IOption[];
    control: FormControl = null;

    constructor(dto: Registration.Form.IElement) {
        this.init(dto);
    }

    private init(dto: Registration.Form.IElement) {
        _.each(Object.keys(dto), (key: string) => {
            this[key] = dto[key];
        });
    }
}
